/**=========================================================
 * Module: client.js
 * Client Controller
 =========================================================*/
 App.controller('ClientController',
    ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', '$filter', 'toaster', 'ngDialog',
        function ($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $filter, toaster, ngDialog) {
            "use strict";

            $scope.type = 'group';
            $scope.id = $state.params.filter;

            $scope.model = {};
            $scope.error = {};
            $scope.page = {
                title: 'labels.MANAGECLIENT',
                subTitle: ''
            };
            $scope.pop = function (type, title, text) {
                toaster.pop(type, title, text, 0, 'trustedHtml');
            };
            $scope.onTab = {}
            $scope.isActiveTab = function(i){
                return $scope.activeTab == i;
            }
            $scope.setActiveTab = function(i){
                $scope.activeTab = i;
                $scope.onTab[i] && $scope.onTab[i]()
            }

            $scope.initialized = false;
            $scope.watchActivated = false;
            $scope.init = function () {
                if ($rootScope.user.id && $scope.id != 'undefined') {
                    $scope.initialized = true;
                    $scope.decimalSep = $rootScope.user.decimalSep;
                    if (!$scope.id) {
                        $scope.id = $rootScope.user.group.id;
                    }

                    $scope.loadFiles = function () {
                        D.query('file', 'entityId=' + $scope.id + '&type=group&field=uploadlogo', {
                            cache: false
                        }).then(
                            function (response) {
                                if (response[0]) {
                                    $scope.model.logo = response[0].url;
                                }

                                $scope.uploadedFiles = response;
                            }
                        ).catch(console.error);
                    };

                    D.load('group', $scope.id).then(function (resp) {
                        $scope.model = resp
                        $scope.page.subTitle = $scope.model.name + ' [' + $scope.model.code + ']'
                        
                        $scope.setActiveTab($scope.activeTab)


                        D.query('supergroup', '').then(function (response) {
                            $scope.supergroups = response;

                                D.query('account', 'group=' + $scope.id + '&_withSGUsers=true').then(function (users) {
                                        $scope.allUsers = users;
                                        $scope.supergroup = $scope.supergroups.find(s => s.id == $scope.model.supergroup)
                                        
                                        for (let oi in $scope.model.opts) {
                                            $scope.model[oi] = $scope.model.opts[oi]
                                        }

                                        if ($scope.model.supergroup) {
                                            $scope.supergroupLines = $scope.supergroups.filter(function (sg) {
                                                return sg.id == $scope.model.supergroup;
                                            })[0].lines;
                                        }
                                        $scope.dataLoaded = true;
                                    },
                                    function (error) {
                                        $scope.error = error;
                                    }
                                ).catch(console.error);
                        }).catch(console.error);

                    }).catch(console.error);
                        
                    
                } else {
                    if (!$scope.watchActivated) {
                        $scope.watchActivated = true;
                        $rootScope.$watch('user.id', function () {
                            if (!$scope.initialized) {
                                $scope.init();
                            }
                        });
                    }
                }
            }

            $scope.init();

            let loadedSessions = 0
            let loadSessions = function (index) {
                D.query('session', 'accountid=' + $scope.accounts[index].id).then(function (r) {
                    loadedSessions++
                    if (loadedSessions == $scope.accounts.length) {
                        $scope.accountsTable.fields.find(function (f) {
                            return f.name == 'lastSeen'
                        }).loadingData = false
                    }
                    let ls = null
                    for (var i = 0; i < r.length; i++) {
                        if (ls === null || r[i].T > ls) ls = r[i].T
                    }
                    $scope.accounts[index].lastSeen = ls
                })
            }

            $scope.onTab.accounts = function(){
                D.query('account', 'group=' + $scope.id + '&_withGroup=true&_withCustom=true').then(
                    function (response) {
                        response.sort((a, b) => {
                            // Prima gli account con superUser = true
                            if (a.superUser && !b.superUser) return -1;
                            if (!a.superUser && b.superUser) return 1;

                            // Poi gli utenti senza customRole
                            if (!a.customRole && b.customRole) return -1;
                            if (a.customRole && !b.customRole) return 1;

                            // Infine, ordinamento per customRole e poi per name
                            if (a.customRole && b.customRole) {
                                if (a.customRole < b.customRole) return -1;
                                if (a.customRole > b.customRole) return 1;
                            }

                            // Secondo criterio di ordinamento: per name
                            return a.name.localeCompare(b.name);
                        })
                        $scope.accounts = []
                        let currentRole = null
                        for(var i=0; i<response.length; i++){
                            response[i].tableRole = response[i].superUser ? 'SUPERUSER' : (response[i].customRole ? response[i].customRole : 'USER')
                            if(response[i].tableRole!=currentRole){
                                $scope.accounts.push({
                                    __separator: true,
                                    __label: (response[i].tableRole=='SUPERUSER' ? $filter('translate')('enums.customRole.SUPERUSERS') : (response[i].tableRole=='USER' ? $filter('translate')('enums.customRole.NORMALUSERS') : $filter('translate')('enums.customRole.' + response[i].customRole + 'S') ))
                                })
                            }
                            currentRole = response[i].tableRole
                            $scope.accounts.push(response[i])
                        }
                    

                        for (var i = 0; i < $scope.accounts.length; i++) {
                            if ($scope.accounts[i].customRole == 'REVIEWER') {
                                $scope.accounts[i].customRoleSuffix = $scope.accounts[i].opts.isDefaultReviewer ? '*' : ''
                                $scope.accounts[i].customRoleSuffix += ' [' + $filter('translate')('enums.language.' + $scope.accounts[i].opts.reviewLanguage) + ']'
                            }
                            if($scope.accounts[i].opts && $scope.accounts[i].opts.gdprcheckdate){
                                $scope.accounts[i].gdprcheckdate = $scope.accounts[i].opts.gdprcheckdate
                            }
                            loadSessions(i)
                        }


                        $scope.accountsTable = {
                            title: '',
                            fields: [{
                                available: true,
                                hasLink: true,
                                name: 'name',
                                conditionalStyle: function(m){
                                    return m.enabled ? null : {'text-decoration': 'line-through'}
                                }
                            }, {
                                available: true,
                                name: 'username',
                                conditionalStyle: function(m){
                                    return m.enabled ? null : {'text-decoration': 'line-through'}
                                }
                            }, {
                                available: true,
                                name: 'email',
                                conditionalStyle: function(m){
                                    return m.enabled ? null : {'text-decoration': 'line-through'}
                                }
                            }, {
                                available: true,
                                name: 'superUser',
                                type: 'boolean'
                            }, {
                                available: true,
                                name: 'enabled',
                                type: 'boolean'
                            }, {
                                available: $scope.accounts.length && $scope.accounts[0].groupType == 'CLIENT' && !!$scope.accounts[0].group.supergroup,
                                name: 'sgUser',
                                label: 'supergroupUser',
                                type: 'boolean'
                            }, {
                                available: true,
                                name: 'customRole',
                                type: 'enum',
                                enumType: 'customRole',
                                suffixField: 'customRoleSuffix'
                            }, {
                                available: true,
                                name: 'lastSeen',
                                type: 'date',
                                format: 'fromNow', //'L HH:mm:ss',
                                loadingData: true
                            },{
                                available: true,
                                name: 'gdprcheckdate',
                                type: 'date',
                                format: 'L HH:mm:ss'
                            }],
                            link: {
                                action: 'view',
                                type: 'user',
                                filter: 'id'
                            },
                            links: [{
                                link: {
                                    action: 'create',
                                    type: 'user',
                                    filterValue: $scope.id
                                },
                                label: 'labels.ADDNEWUSER',
                                icon: 'aqi-action-add'
                            }]
                        }
                    },
                    function (error) {
                        $scope.error = error;
                    }
                ).catch(console.error);
            }

            $scope.onTab.general = function(){ $scope.loadForm('general') }
            $scope.onTab.discount = function(){ $scope.loadForm('discount') }
            $scope.onTab.tm = function(){ $scope.loadForm('tm') }
            $scope.onTab.notification = function(){ $scope.loadForm('notification') }
            $scope.onTab.project = function(){ $scope.loadForm('project') }
            $scope.onTab.fields = function(){ $scope.loadForm('fields') }
            $scope.onTab.packet = function(){ $scope.loadForm('packet') }
            $scope.onTab.sectors = function(){ $scope.loadForm('sectors') }
            $scope.onTab.review = function(){ $scope.loadForm('review') }
            $scope.onTab.glossary = function(){ $scope.loadForm('glossary') }

            $scope.loadForm = function(section){
                $scope.formModel = {};
                //angular.copy($scope.model,$scope.formModel);
                $scope.formModel = JSON.parse(JSON.stringify($scope.model));
                $scope.form = {
                    title: 'labels.EDITSETTINGS',
                    status: '',
                    type: 'group',
                    model: $scope.formModel,
                    fields: [
                        {
                            available: section=='general',
                            type: 'text',
                            name: 'name',
                            required: true,
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            label: 'fields.LOGO',
                            uploadLabel: 'fields.UPLOADLOGO',
                            available: section=='general',
                            type: 'pictureFile',
                            name: 'uploadlogo',
                            targetField: 'logo',
                            limit: 1,
                            canUpload: true,
                            allow: 'jpg|jpeg|png',
                            public: true,
                            bucket: $rootScope.bucketName($scope.model.id),
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='general',
                            type: 'select',
                            name: 'supergroup',
                            data: $scope.supergroups,
                            valueField: 'id',
                            labelField: 'name',
                            placeholder: 'labels.NONE',
                            onchange: function () {
                                $scope.form.fields.filter(function (f) {
                                    return f.name == 'supergroupLine';
                                })[0].available = !!$scope.model.supergroup;
                                $scope.form.fields.filter(function (f) {
                                    return f.name == 'supergroupLine';
                                })[0].data = $scope.supergroups.filter(function (sg) {
                                    return sg.id == $scope.model.supergroup;
                                })[0].lines
                                $timeout(function () {
                                    angular.element('select[name=supergroupLine]').chosen('destroy').chosen()
                                }, 500);
                            },
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: !!$scope.model.supergroup && section=='general',
                            type: 'select',
                            name: 'supergroupLine',
                            data: $scope.supergroupLines,
                            valueField: 'id',
                            labelField: 'name',
                            placeholder: 'labels.NONE',
                            label: 'fields.LINE',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='discount',
                            type: 'text',
                            name: 'discountContext',
                            label: $scope.model.id == 'stl' ? 'fields.DISCOUNTMATCH100' : 'fields.DISCOUNTCONTEXT',
                            required: true,
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='discount',
                            type: 'text',
                            name: 'discountFull',
                            label: $scope.model.id == 'stl' ? 'fields.DISCOUNTMATCH9599' : 'fields.DISCOUNTFULL',
                            required: true,
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='discount',
                            type: 'text',
                            name: 'discountFuzzy',
                            label: $scope.model.id == 'stl' ? 'fields.DISCOUNTMATCH7594' : 'fields.DISCOUNTFUZZY',
                            required: true,
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='discount',
                            type: 'text',
                            name: 'discountNo',
                            label: $scope.model.id == 'stl' ? 'fields.DISCOUNTMATCH074' : 'fields.DISCOUNTNO',
                            required: true,
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='tm',
                            type: 'checkbox',
                            name: 'searchmemories',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='notification',
                            type: 'checkbox',
                            name: 'selfnotifications',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='project',
                            type: 'checkbox',
                            name: 'skipSourceReport',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: $scope.model.type == 'SUPPLIER',
                            type: 'checkbox',
                            name: 'manageTranslators',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: $scope.model.type == 'SUPPLIER',
                            type: 'checkbox',
                            name: 'canviewcsv',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='tm',
                            type: 'checkbox',
                            name: 'canaskfortm',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='fields',
                            type: 'checkbox',
                            name: 'offerDlFieldWTime',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='project',
                            type: 'checkbox',
                            name: 'hasImportProject',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='notification',
                            type: 'checkbox',
                            name: 'receiveOfferPdf',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='notification',
                            type: 'checkbox',
                            name: 'receiveDelivered',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='packet',
                            type: 'checkbox',
                            name: 'viewPacketTransactions',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='packet',
                            type: 'checkbox',
                            name: 'doNotSubtractTranslatedWords',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='project',
                            type: 'checkbox',
                            name: 'autodelivery',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='fields',
                            type: 'checkbox',
                            name: 'noDtpInOffers',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='project',
                            type: 'checkbox',
                            name: 'skipConfirm',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='project',
                            type: 'decimal',
                            displayType: 'decimal',
                            decimalSep: $rootScope.user.decimalSep,
                            decimals: 0,
                            name: 'skipConfirmLimit',
                            labelParams: {
                                currency: $scope.model.currency
                            },
                            postfix: $filter('translate')('enums.currencySymbol.' + ($scope.model.currency)),
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='project',
                            type: 'checkbox',
                            name: 'canUploadAsLink',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='packet',
                            type: 'checkbox',
                            name: 'previewWords',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='project',
                            type: 'select',
                            name: 'joinProjectsDefaultUser',
                            data: $scope.allUsers,
                            valueField: 'id',
                            labelField: 'name',
                            placeholder: 'labels.NONE',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='sectors',
                            type: 'checkbox',
                            name: 'hasSectorInProject',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='review',
                            type: 'checkbox',
                            name: 'hasReviewInProject',
                            onchange: function () {
                                $scope.form.fields.forEach(function (f) {
                                    if (f.name == 'sourceFilesInReview' || f.name == 'hasReviewDeadline' || f.name == 'reviewMode' || f.name == 'canAnticipateReview') {
                                        f.available = $scope.model.hasReviewInProject
                                    }
                                });
                            },
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='review' && $scope.model.hasReviewInProject,
                            type: 'checkbox',
                            name: 'canAnticipateReview',
                            labelColumn: 4,
                            inputColumn: 8
                        },{
                            available: section=='review' && $scope.model.hasReviewInProject,
                            type: 'checkbox',
                            name: 'sourceFilesInReview',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='review' && $scope.model.hasReviewInProject,
                            type: 'checkbox',
                            name: 'hasReviewDeadline',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='review' && $scope.model.hasReviewInProject,
                            type: 'select',
                            name: 'reviewMode',
                            data: [{
                                value: '',
                                label: 'standard'
                            }, {
                                value: 'memoQ',
                                label: 'memoQ'
                            }],
                            valueField: 'value',
                            labelField: 'label',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='sectors',
                            type: 'checkbox',
                            name: 'maxOneUserPerSector',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='sectors',
                            type: 'checkbox',
                            name: 'acceptingUserFromSector',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='project',
                            type: 'checkbox',
                            name: 'hasQAi',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='project',
                            type: 'checkbox',
                            name: 'defaultSourceFilesVisible',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='glossary',
                            type: 'checkbox',
                            name: 'hasGlossary',
                            onchange: function () {
                                $scope.form.fields.filter(function (f) {
                                    return f.name == 'glossary';
                                })[0].available = !!$scope.model.hasGlossary;
                            },
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='glossary' && $scope.model.hasGlossary,
                            type: 'file',
                            name: 'glossary',
                            limit: -1,
                            canUpload: true,
                            canAddInstructions: true,
                            bucket: $rootScope.bucketName($scope.model.id),
                            filesSelectable: $rootScope.user.admin,
                            selectionActions: [{
                                icon: 'aqi-action-delete',
                                label: 'labels.DELETE',
                                action: 'delete'
                            }],
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: section=='packet',
                            type: 'decimal',
                            displayType: 'decimal',
                            decimalSep: $rootScope.user.decimalSep,
                            decimals: 0,
                            name: 'recoveredPricePercentage',
                            labelColumn: 4,
                            inputColumn: 8
                        }, {
                            available: true,
                            type: 'submit',
                            name: 'empty',
                            label: 'fields.SAVE',
                            labelColumn: 4,
                            inputColumn: 8
                        }
                    ],
                    submit: function () {
                        $scope.form.status = 'submitting';
                        D.save($scope.type, $scope.formModel).then(
                            function (response) {
                                $scope.form.status = 'submitted';
                                $scope.model = response;
                                for (let oi in $scope.model.opts) {
                                    $scope.model[oi] = $scope.model.opts[oi]
                                }
                            }

                        ).catch(function (response) {
                            $scope.form.status = 'error';
                        });
                    }
                };
                $scope.loadFiles();
            }
        }
    ]);